import axios from 'axios';

const api = axios.create({
  baseURL: '/api/v1',
  timeout: 30000,
});

// Request interceptor to add auth headers
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mft-token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear all auth-related data on unauthorized
      localStorage.removeItem('mft-token');
      localStorage.removeItem('mft-user');
      localStorage.removeItem('mft-expires');
      window.location.href = '/ui/login';
    }
    return Promise.reject(error);
  }
);

export default api;